import { Link } from 'react-router-dom';
import '../index.css';

const Product4 = () => {
  return (
    <div className="product-detail-page">
      <header className="products-header">
        <div className="section-inner">
          <Link to="/produtos" className="back-button">
            ← Voltar para Produtos
          </Link>
          <h1 className="products-title">Vou Migrar Seu Projeto Do Lovable Cloud Para o Supabase</h1>
          <p className="products-subtitle">Migração completa e profissional do seu projeto</p>
        </div>
      </header>

      <section className="coming-soon-section">
        <div className="section-inner">
          <div className="coming-soon-box">
            <img src="https://static.lumi.new/11/1147707eed9643322369a4fe31c060f9.webp" alt="Migração Lovable Cloud para Supabase" style={{ width: '100%', maxWidth: 400, borderRadius: 16, marginBottom: 24 }} />
            <h2>Vou Migrar Seu Projeto Do Lovable Cloud Para o Supabase</h2>
            <p>Migração completa, segura e profissional do seu banco de dados Lovable Cloud para o Supabase. Sem perda de dados!</p>
            <Link to="/migracao" className="cta-button-primary">
              Ver Todos os Produtos
            </Link>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="section-inner">
          <div className="footer-brand">
            <img src="https://static.lumi.new/00/0011bb058a2686e447915d0083474f56.webp" alt="Mestre Lovable Infinity" className="footer-logo" />
            <span className="footer-name">Extensão Lovable Ilimitado</span>
          </div>
          <p className="footer-copy">&copy; 2026 Mestre do Lovable - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default Product4;
